export default "/images/SL_avant.png?14d58569c7b1ec3b0e8eb023088c367a";